var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"feature-card"},[_c('img',{staticClass:"img",attrs:{"src":_vm.image}}),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"desc"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }